import { MediaTypes } from 'helpers/constants/MediaTypes';
import { RoutePaths } from 'helpers/constants/RoutePaths';
import { Application, Step } from 'interfaces';
import { makeObservable, observable } from 'mobx';

export class KioskApplication {
    @observable
    public id: string;
    public applicationName: string;
    @observable
    public logo: string;
    public logoMediaType: string;
    public url: string;
    public position: number;
    public isActive: boolean;
    public enableUpSell: boolean;
    public enableHandshake: boolean;
    public enableGracefulClose: boolean;
    @observable
    public steps: Step[];

    constructor(application: Application) {
        Object.assign(this, application);
        this.id = application.appId;
        this.applicationName = application.name;
        this.isActive = application.enable;

        if (this.logoMediaType == null) {
            this.logoMediaType = MediaTypes.imagePng;
        }

        makeObservable(this);
    }

    get path(): string {
        return `${RoutePaths.ApplicationSelect.replace(/\/$/, '')}/${this.id}`;
    }
}
